import { initSlider, visibilityItem } from './slider-util';

export const initBrandsSlider = () => {
    const selector = '.brands-slider';
    const itemSelector = '.brands-slide';

    visibilityItem(selector);
    const sliderConfig = (items) => {
        const defaultShowItem = 8;
        return {
            infinite: true,
            slidesToShow: items < defaultShowItem ? items : defaultShowItem,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }
            ]
        };
    };

    window.require(['slick'], () => {
        document.querySelectorAll(selector).forEach((parentElement) => {
            const childrenItem = parentElement.querySelectorAll(itemSelector);

            initSlider(parentElement, sliderConfig(childrenItem.length));
        });
    });
};
